// src/hooks/useSeedInventoryQuery.ts
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

function useSeedInventoryQuery(
	defaultUuid: string,
	pageSlug: string,
	tableSlug: string,
	tableViewUuid: string
) {
	const { search, pathname } = useLocation();
	const navigate = useNavigate();
	// const { pageSlug, viewSlug, routeKeys } = inventoryConfig;
	const paramName = `${tableSlug}:group`;

	useEffect(() => {
		const params = new URLSearchParams(search);

		// pull out any existing pagination keys
		const perPageKey = `${pageSlug}_recordsPerPage`;
		const pageKey = `${pageSlug}_page`;
		const savedPerPage = params.get(perPageKey);
		const savedPage = params.get(pageKey);
		if (savedPerPage) params.delete(perPageKey);
		if (savedPage) params.delete(pageKey);

		// seed the group filter if missing
		const hasDeepLink = Array.from(params.keys()).some((k) =>
			k.startsWith(`${tableSlug}:`)
		);
		if (!params.has(paramName) && !hasDeepLink) {
			params.set(paramName, defaultUuid);
		}

		// re-append pagination at end
		if (savedPerPage) params.set(perPageKey, savedPerPage);
		if (savedPage) params.set(pageKey, savedPage);

		// replace in one go
		navigate(
			{ pathname, search: `?${params.toString()}` },
			{ replace: true }
		);
	}, [
		search,
		pathname,
		navigate,
		paramName,
		defaultUuid,
		tableSlug,
		pageSlug,
	]);
}

export default useSeedInventoryQuery;
